import { render, staticRenderFns } from "./UserDesignation.vue?vue&type=template&id=7dd13462&scoped=true"
import script from "./UserDesignation.vue?vue&type=script&lang=ts"
export * from "./UserDesignation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd13462",
  null
  
)

export default component.exports